module.exports = __webpack_public_path__ + "fonts/0a0d1008d732e4cf82c24f7bb64919cc.svg";